module.exports = __webpack_public_path__ + "img/NARDA.d11b5aa7.png";